import React from 'react';
import useCountdown from '@/hook/useCountdown';

const CountdownTimer = ({ endDate, bgColor = '#ffffff33', timerHeading }) => {
    const timeLeft = useCountdown(endDate);

    if (!timeLeft) return <span className="text-white text-center text-xl">Time's up!</span>;

    const timeUnits = [
        { label: 'DAYS', value: timeLeft.days },
        { label: 'HOURS', value: timeLeft.hours.toString().padStart(2, '0') },
        { label: 'MINUTES', value: timeLeft.minutes.toString().padStart(2, '0') },
        { label: 'SECONDS', value: timeLeft.seconds.toString().padStart(2, '0') },
    ];

    const isHex = bgColor.startsWith('#');

    return (
        <div className="text-white text-center">
            <h2 className="text-lg font-bold mb-2">{timerHeading}</h2>
            <div className="flex justify-center gap-2">
                {timeUnits.map((unit, idx) => (
                    <div
                        key={idx}
                        className="backdrop-blur-sm rounded-md px-3 py-2 w-[70px] sm:w-20 md:min-w-[60px]"
                        style={isHex ? { backgroundColor: bgColor } : {}}
                    >
                        <div className="md:text-2xl font-bold">{unit.value}</div>
                        <div className="text-[10px] md:text-xs font-medium tracking-wide">{unit.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CountdownTimer;
